var _circle, _g, _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyWishlist = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 228,
  height: 209,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 104.086,
  cy: 104.086,
  r: 104.086,
  fill: "#F8F8F8"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#empty-wishlist_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 170.042,
  height: 145.775,
  x: 10.521,
  y: 42.414,
  fill: "#fff",
  rx: 13.351,
  transform: "rotate(-7.274 10.52 42.414)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E7E7E7",
  d: "M20.291 56.548a5.995 5.995 0 0 1 5.188-6.705l141.088-18.009a5.994 5.994 0 0 1 6.705 5.187l8.108 63.517-152.981 19.527z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 130.626,
  height: 5.995,
  x: 41.688,
  y: 135.949,
  fill: "#BCBCBC",
  rx: 2.997,
  transform: "rotate(-7.274 41.688 135.949)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 88.555,
  height: 5.995,
  x: 44.413,
  y: 157.301,
  fill: "#BCBCBC",
  rx: 2.997,
  transform: "rotate(-7.274 44.413 157.301)"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 168.68,
  height: 144.413,
  x: 11.283,
  y: 43.004,
  stroke: "#E3E3E3",
  strokeWidth: 1.362,
  rx: 12.67,
  transform: "rotate(-7.274 11.283 43.004)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3F3F3",
  stroke: "#B1B5B5",
  strokeWidth: 1.091,
  d: "M21.146 24.857a9.17 9.17 0 0 0 5.782 5.777 9.17 9.17 0 0 0-5.783 5.775 9.18 9.18 0 0 0-5.783-5.775 9.17 9.17 0 0 0 5.783-5.777ZM135.146 164.857a9.17 9.17 0 0 0 5.782 5.777 9.17 9.17 0 0 0-5.782 5.775 9.18 9.18 0 0 0-5.784-5.775 9.18 9.18 0 0 0 5.784-5.777Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-wishlist_svg__b)",
  d: "M165.564 139.19c-1.828 14.646 9.305 23.961 17.294 32.055 2.818 2.853 5.54 5.551 8.552 5.927s6.313-1.567 9.748-3.646c9.735-5.875 22.814-12.171 24.641-26.814 1.828-14.643-13.439-27.105-28.75-14.713-11.795-15.775-29.657-7.455-31.485 7.191"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-wishlist_svg__b",
  x1: 190.977,
  x2: 220.982,
  y1: 149.094,
  y2: 180.262,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5484D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A5191E"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "empty-wishlist_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 170.042,
  height: 145.775,
  x: 10.521,
  y: 42.414,
  fill: "#fff",
  rx: 13.351,
  transform: "rotate(-7.274 10.52 42.414)"
})))));
export { SvgEmptyWishlist as ReactComponent };
export default __webpack_public_path__ + "73ab2b395d07cefe1f8d3efa55bccff9.svg";